import { render, staticRenderFns } from "./NavigationQuicksearchMenuItem.vue?vue&type=template&id=1406b1af&scoped=true&"
import script from "./NavigationQuicksearchMenuItem.vue?vue&type=script&lang=js&"
export * from "./NavigationQuicksearchMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./NavigationQuicksearchMenuItem.vue?vue&type=style&index=0&id=1406b1af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1406b1af",
  null
  
)

export default component.exports